import type {
  IHttpCall,
  IHttpRequest,
  IHttpResponse,
} from '@hc-frontend/core-utils-net';
import { fetchBasedCall } from '@hc-frontend/core-utils-net';

import { SaveActionRequestDto } from './save-action.types';

export type SaveActionOptions = Partial<Omit<IHttpRequest<void>, 'body'>> & {
  httpCall?: IHttpCall;
};

export function saveAction(
  baseUrl: string,
  payload: SaveActionRequestDto,
  options?: SaveActionOptions,
): Promise<IHttpResponse<undefined>> {
  const { httpCall = fetchBasedCall, headers, ...restOptions } = options ?? {};
  const request: IHttpRequest<SaveActionRequestDto> = {
    url: `${baseUrl}/api/v2/journeys/actions`,
    method: 'POST',
    body: payload,
    headers,
    schemas: {
      request: SaveActionRequestDto,
    },
    ...restOptions,
  };

  return httpCall(request);
}
